<template>
  <div>
    <div class="qyzz">
      <div class="qyzzfirstbf">
        <div>
          <img src="../../assets/img/qyzztitle1.png" alt="">
          <ul class="uploadqyzzzj">
            <li v-for="(item, i) in imgListArray" :key="i">
              <img
                v-preventReClick
                :src="item.imageurl"
                alt=""
                @click="imageClick(item.name, item.zjlx)"
              >
              <div>
                <p v-html="item.xianshi" />
                <el-button
                  v-preventReClick
                  type="primary"
                  plain
                  @click="imageClickHistory(item.name, item.zjlx)"
                >同单位基本信息下的资质证件</el-button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="qyzzsecondbf">
        <div>
          <img src="../../assets/img/qyzztitle2.png" alt="">

          <el-table
            v-if="historyflag"
            :data="imagetableDataHistory"
            border
            style="width: 100%"
            max-height="420"
            :header-cell-style="{ background: '#F2F2F2' }"
          >
            <el-table-column
              v-for="(item, i) in headerHistroylist"
              :key="i"
              :prop="item.prop"
              :label="item.label"
              align="center"
            />
            <el-table-column label="操作" width="150" align="center">
              <template slot-scope="scope">
                <el-button
                  v-preventReClick
                  type="primary"
                  icon="el-icon-view"
                  size="mini"
                  style="background-color: #4170ff"
                  @click="handleView1(scope.$index, scope.row)"
                >查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <dialogqyzz
          ref="dialogqyzz"
          :dialog-form-visible="dialogFormVisible"
          :title="title"
          :zjlx="imagezjlx"
          @close-dialog="closeDialog"
          @getFjTableMess="getFjTableMess1"
        />
      </div>
    </div>
    <!-- 打开许可证弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogFormVisible1"
      center
      custom-class="zhengjiatable"
    >
      <el-table
        :data="imagetableData"
        border
        style="width: 100%"
        max-height="420"
        :header-cell-style="{ background: '#F2F2F2' }"
      >
        <el-table-column
          v-for="(item, i) in headerlist"
          :key="i"
          align="center"
          :prop="item.prop"
          :label="item.label"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              v-preventReClick
              type="primary"
              icon="el-icon-view"
              size="mini"
              style="background-color: #4170ff"
              @click="handleView(scope.$index, scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 许可证弹窗的弹窗start -->
      <dialogqyzz
        ref="dialogqyzz"
        :dialog-form-visible="dialogFormVisible"
        :title="title"
        :zjlx="imagezjlx"
        @close-dialog="closeDialog"
        @getFjTableMess="getFjTableMess1"
      />
      <!-- 许可证弹窗的弹窗end -->
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="
            background-color: #4170ff;
            width: 90px;
            height: 40px;
            margin-bottom: 20px;
          "
          @click="dialogFormVisible1 = false"
        >关闭</el-button>
      </div>
    </el-dialog>
    <!-- 打开许可证弹窗end -->
  </div>
</template>
<script>
import dialogqyzz from './dialogqyzz.vue'
import {
  getqyzzzzlx,
  getqyzzFjmes,
  getqyzzFjDetailmes,
  getqyzzHistroyFjmes,
  getqyzzHistroyFjDetailmes
} from '@/assets/js/common.js'
export default {
  components: {
    dialogqyzz
  },
  data() {
    return {
      headerHistroylist: [], // 历史列表
      title: '', // 传给弹出框的标题
      dialogVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      imagezjlx: 0,
      hiszjlx: '',
      headerlist: [], // 表头
      tableData: [],
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 总条数
      imagetableData: [], // image列表table
      imagetableDataHistory: [], // 历史列表
      imgListArray: [], // 许可证图片
      historyflag: false
    }
  },
  created() {
    this.imageChange() // 许可证变化
  },
  methods: {
    // 许可证变化
    async imageChange() {
      var zjlxList = []
      await getqyzzzzlx().then((e) => {
        zjlxList = e.data.data
      })
      this.imgListArray = []
      zjlxList.includes('1')
        ? this.imgListArray.push({
          zjlx: 1,
          name: '营业执照',
          xianshi: '营业执照',
          imageurl: require('../../assets/img/gmsqyyzz_down.png'),
          flag: false
        })
        : ''
      zjlxList.includes('6')
        ? this.imgListArray.push({
          zjlx: 6,
          name: '安全生产许可证',
          xianshi: '安全生产许可证',
          imageurl: require('../../assets/img/step41.png'),
          flag: false
        })
        : ''
      zjlxList.includes('2')
        ? this.imgListArray.push({
          zjlx: 2,
          name: '非药品类易制毒化学品生产许可证',
          xianshi: '非药品类易制毒化学品生产许可证',
          imageurl: require('../../assets/img/step42.png'),
          flag: true
        })
        : ''
      zjlxList.includes('13')
        ? this.imgListArray.push({
          zjlx: 13,
          name: '非药品类易制毒化学品生产备案证明',
          xianshi: '非药品类易制毒化学品生产备案证明',
          imageurl: require('../../assets/img/step43.png'),
          flag: true
        })
        : ''

      zjlxList.includes('16')
        ? this.imgListArray.push({
          zjlx: 16,
          name: '危险化学品经营许可证',
          xianshi: '危险化学品经营许可证',
          imageurl: require('../../assets/img/step47.png'),
          flag: false
        })
        : ''

      zjlxList.includes('22')
        ? this.imgListArray.push({
          zjlx: 22,
          name: '合法使用需要证明',
          xianshi: '合法使用需要证明',
          imageurl: require('../../assets/img/step44.png'),
          flag: false
        })
        : ''

      zjlxList.includes('3')
        ? this.imgListArray.push({
          zjlx: 3,
          name: '非药品类易制毒化学品经营许可证',
          xianshi: '非药品类易制毒化学品经营许可证',
          imageurl: require('../../assets/img/step46.png'),
          flag: true
        })
        : ''

      zjlxList.includes('17')
        ? this.imgListArray.push({
          zjlx: 17,
          name: '非药品类易制毒化学品经营备案证明',
          xianshi: '非药品类易制毒化学品经营备案证明',
          imageurl: require('../../assets/img/step48.png'),
          flag: true
        })
        : ''
      zjlxList.includes('12')
        ? this.imgListArray.push({
          zjlx: 12,
          name: '道路运输经营许可证',
          xianshi: '道路运输经营许可证',
          imageurl: require('../../assets/img/step49.png'),
          flag: true
        })
        : ''

      zjlxList.includes('24')
        ? this.imgListArray.push({
          zjlx: 24,
          name: '危险货物道路运输许可证',
          xianshi: '危险货物道路运输许可证',
          imageurl: require('../../assets/img/step410.png'),
          flag: false
        })
        : ''

      zjlxList.includes('23')
        ? this.imgListArray.push({
          zjlx: 23,
          name: '其他证件',
          xianshi: '其他证件',
          imageurl: require('../../assets/img/step45.png'),
          flag: false
        })
        : ''
    },
    // 许可证弹窗
    imageClick(name, zjlx) {
      this.title = name
      this.imagezjlx = zjlx
      this.getFjTableMess(zjlx)
      this.dialogFormVisible1 = true
    },
    // 证件历史
    imageClickHistory(name, zjlx) {
      this.title = name
      this.hiszjlx = zjlx
      this.historyflag = true
      this.getFjTableHistoryMess(zjlx)
    },
    // 获得许可证历史列表信息
    getFjTableHistoryMess(zjlx) {
      // 查询许可证附件table信息
      getqyzzHistroyFjmes(zjlx).then((e) => {
        this.imagetableDataHistory = e.data.data
        switch (zjlx) {
          case 1:
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'dz', label: '单位地址' },
              { prop: 'fzr', label: '法人/经营者' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'fzrq', label: '发证日期' },
              { prop: 'fzjg', label: '发证机关' }
            )
            break
          case 2: // 非药品类易制毒化学品生产许可证
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'pzcl', label: '生产品种' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'fzjg', label: '发证机关' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 3: // 非药品类易制毒化学品经营许可证
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'tyshxydm', label: '统一社会信用代码' },
              { prop: 'pzcl', label: '经营品种' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 13: // 非药品类易制毒化学品生产备案证明
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'pzlb', label: '品种类别' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 17: // 非药品类易制毒化学品经营备案证明
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'tyshxydm', label: '统一社会信用代码' },
              { prop: 'pzcl', label: '经营品种' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 6: // 安全生产许可证
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'jyfw', label: '许可范围' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break

          case 22: // 合法使用需要证明
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'hxpMcs', label: '化学品名称' },
              { prop: 'sjl', label: '涉及量' },
              { prop: 'fzrq', label: '签订日期' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 16: // 危险化学品经营许可
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '单位法定代表人' },
              { prop: 'jyfw', label: '许可范围' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 12: // 道路运输经营许可
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '业户名称' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 23: // 其他证件
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zsmc', label: '证书名称' },
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 24: // 危险货物道路运输许可证
            this.headerHistroylist = []
            this.headerHistroylist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '业户名称' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'fzrq', label: '发证日期' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          default:
            break
        }
      })
    },
    // 获得许可证弹窗列表信息
    getFjTableMess(zjlx) {
      // 查询许可证附件table信息
      getqyzzFjmes(zjlx).then((e) => {
        this.imagetableData = e.data.data
        switch (zjlx) {
          case 1:
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'dz', label: '单位地址' },
              { prop: 'fzr', label: '法人/经营者' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'fzrq', label: '发证日期' },
              { prop: 'fzjg', label: '发证机关' }
            )
            break
          case 2: // 非药品类易制毒化学品生产许可证
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'pzcl', label: '生产品种' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 3: // 非药品类易制毒化学品经营许可证
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'pzcl', label: '经营品种' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 13: // 非药品类易制毒化学品生产备案证明
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'pzlb', label: '生产品种' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 17: // 非药品类易制毒化学品经营备案证明
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'pzcl', label: '经营品种' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 6: // 安全生产许可证
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '主要负责人' },
              { prop: 'jyfw', label: '许可范围' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break

          case 22: // 合法使用需要证明
            this.headerlist = []
            this.headerlist.push(
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'hxpMcs', label: '化学品名称' },
              { prop: 'sjl', label: '涉及量' },
              { prop: 'fzrq', label: '签订日期' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 16: // 危险化学品经营许可
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '单位名称' },
              { prop: 'fzr', label: '单位法定代表人' },
              { prop: 'jyfw', label: '许可范围' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 12: // 道路运输经营许可
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '业户名称' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 23: // 其他证件
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zsmc', label: '证件名称' },
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          case 24: // 危险货物道路运输许可证
            this.headerlist = []
            this.headerlist.push(
              { prop: 'zjbh', label: '证件编号' },
              { prop: 'dwmc', label: '业户名称' },
              { prop: 'yxqKs', label: '有效期开始' },
              { prop: 'yxqJs', label: '有效期结束' },
              { prop: 'fzrq', label: '发证日期' },
              { prop: 'statusLabel', label: '状态' }
            )
            break
          default:
            break
        }
      })
    },
    getFjTableMess1(val) {
      this.imagetableData = val
    },
    // 查看弹窗列表信息中的详细信息
    handleView(index, row) {
      this.dialogFormVisible = true
      this.type = true
      getqyzzFjDetailmes(row.id, this.imagezjlx).then((e) => {
        this.$refs.dialogqyzz.csh(e.data.data)
      })
    },
    handleView1(index, row) {
      this.dialogFormVisible = true
      this.type = true
      getqyzzHistroyFjDetailmes(row.id, this.hiszjlx).then((e) => {
        this.$refs.dialogqyzz.csh(e.data.data)
      })
    },
    // 关闭许可证弹窗的弹窗
    closeDialog(val1, val2) {
      this.dialogFormVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
.qyzz {
  width: 95%;
  margin: 0 auto;
  max-width: 1518px;
  .qyzzfirstbf {
    margin-top: 30px;
    margin-bottom: 6px;
    background-color: #fff;
    & > div {
      width: 90%;
      margin: 0 auto;
      & > img {
        width: 127px;
        height: 22px;
        margin: 39px 0 53px 0px;
      }
      .uploadqyzzzj {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
        padding-bottom: 43px;
        li {
          list-style: none;
          display: flex;

          flex-direction: column;
          align-items: center;
          margin-bottom: 10px;
          img {
            width: 158px;
            height: 111px;
            margin: 0 42.5px;
          }
          & > div {
            text-align: center;
            p {
              height: 18px;
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 18px;
              margin: 5px auto 10px auto;
            }
            .el-button {
              //   width: 76px;
              //   height: 28px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              // color: #2860ec;
              line-height: 20px;
              padding: 4px 10px;
            }
          }
        }
      }
    }
  }
  /deep/ .qyzzsecondbf {
    background-color: #fff;
    padding-bottom: 322px;
    & > div {
      width: 90%;
      margin: 0 auto;
      img {
        margin: 35px 0 35px 0px;
        width: 91px;
        height: 22px;
      }
    }
  }
}
/deep/.zhengjiatable {
  width: 960px;
  .el-dialog__title {
    display: block;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    margin: 30px auto 0px;
  }

  .el-dialog__body {
    overflow: auto;
  }
  .el-table--border,
  .el-table--group {
    border: 1px solid #ebeef5 !important;
  }
}
</style>
